import { globalAlert } from '../../ts/instances/alerts';
import './app-page.scss';
globalAlert();